import script from "./find-contact-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./find-contact-modal.vue?vue&type=script&setup=true&lang=ts"

import "./find-contact-modal.vue?vue&type=style&index=0&id=2be4971e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be4971e"]])

export default __exports__